import { render, staticRenderFns } from "./ReviewsVue.vue?vue&type=template&id=0f9735f1&scoped=true&"
import script from "./ReviewsVue.vue?vue&type=script&lang=js&"
export * from "./ReviewsVue.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsVue.vue?vue&type=style&index=0&id=0f9735f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9735f1",
  null
  
)

export default component.exports